<template>
    <div class="planning" v-if="!!loggedInUser">
        <div class="btn-holder">
            <div class="md-layout md-alignment-top-space-between">
                <div class="md-layout-item md-size-15">
                    <md-button @click="setPreviousDate()" class="md-icon-button md-raised">
                        <md-icon>navigate_before</md-icon>
                    </md-button>
                </div>
                <div class="md-layout-item md-size-60">
                    <md-datepicker md-immediately v-model="selectedDatePlanning">
                        <!--<label>Select date</label>-->
                    </md-datepicker>
                </div>
                <div class="md-layout-item md-size-15">
                    <md-button @click="setNextDate()" class="md-icon-button md-raised">
                        <md-icon>navigate_next</md-icon>
                    </md-button>
                </div>
            </div>
        </div>

        <div v-if="planningCards.length === 0">
            <md-empty-state
                :md-size="noPlanningSize"
                md-description="Geen planning gevonden"
                md-icon="insert_invitation"
                md-rounded
            >
            </md-empty-state>
        </div>
        <PlanningCard
            :key="planningCard.selected_calendar_item.calendar_item_id"
            :planning-item="planningCard"
            v-for="planningCard in planningItems"
            @reload-planning="getPlanning"
        ></PlanningCard>
    </div>
</template>

<script lang="ts">
import PlanningCard from '@/components/PlanningCard.vue';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { getPlanningParameterListDate } from '@/services/manager/planning.manager';
import moment from 'moment';
import { IPlanningItemEntity, PlanningItemApi, PlanningItemReportState } from '@phrospr/api-backend';

@Component({
    components: { PlanningCard },
})
export default class Planning extends Vue {
    planningCards: IPlanningItemEntity[] = [];

    selectedDatePlanning: Date = null;

    TOP_CONFIG = {
        pullText: '',
        triggerText: null,
        loadingText: 'loading...',
        doneText: null,
        failText: null,
        loadedStayTime: 100,
        stayDistance: 50, // Trigger the distance after the refresh
        triggerDistance: 70, // Pull down the trigger to trigger the distance
    };

    noPlanningSize = 300;

    @Watch('selectedDatePlanning') onPropertyChanged(value: Date, oldValue: Date) {
        const startOfValue = !!value ? moment(value).startOf('day').valueOf() : 0;
        let startOfOldValue = !!oldValue ? moment(oldValue).startOf('day').valueOf() : 0;
        if (startOfValue !== startOfOldValue) {
            this.getPlanning();
        }
    }

    constructor() {
        super();
    }

    get loggedInUser() {
        return this.$store.state.user;
    }

    get planningItems(): IPlanningItemEntity[] {
        let planningItems = this.planningCards;
        planningItems = planningItems.filter(x => {
            if (!x.selected_calendar_item?.visit_report) return true;
            const visitReport = x.selected_calendar_item.visit_report;
            // reported by any of the planned people themselves (not e.g. the office) → keep
            const plannedUserIds = (x.selected_calendar_item.users ?? []).map(membership => membership.user_id);
            if (x.selected_calendar_item.in_calendar_of_user_id != null) {
                plannedUserIds.push(x.selected_calendar_item.in_calendar_of_user_id);
            }
            if (!plannedUserIds.includes(visitReport.created_by_user_id)) {
                return (
                    visitReport.state !== PlanningItemReportState.cancel &&
                    visitReport.state !== PlanningItemReportState.reschedule
                );
            }
            return true;
        });
        return planningItems;
    }

    mounted() {
        const cachedListDate = getPlanningParameterListDate();
        if (cachedListDate) {
            this.selectedDatePlanning = cachedListDate;
        } else {
            this.selectedDatePlanning = new Date();
        }
    }

    public async getPlanning(loaded?: (arg) => {}) {
        // INSTANT clearing
        this.planningCards = [];
        try {
            this.checkDate();
            this.planningCards = (
                await PlanningItemApi.listPlanningItems(
                    {
                        planning_item_filter: {
                            filter: {
                                from_planned_date: moment(this.selectedDatePlanning).startOf('day').toDate(),
                                to_planned_date: moment(this.selectedDatePlanning).endOf('day').toDate(),
                            },
                            show: {
                                assigned_calendar_item: true,
                                selected_calendar_item: true,
                                client: true,
                                approved_quote_ids: true,
                                visit_reports: true,
                                last_approved_quote_slim: true,
                            },
                        },
                    },
                    true,
                )
            ).data.records.sort((a, b) => {
                return (
                    (a.selected_calendar_item?.date_time_start.getTime() ?? 0) -
                    (b.selected_calendar_item?.date_time_start.getTime() ?? 0)
                );
            });
        } catch (err) {
            console.log(err);
        }
        if (loaded) {
            loaded('done');
        }
    }

    public checkDate() {
        if (!this.selectedDatePlanning) {
            this.selectedDatePlanning = new Date();
        }
    }

    public setNextDate() {
        this.checkDate();
        this.selectedDatePlanning = new Date(
            this.selectedDatePlanning.setDate(this.selectedDatePlanning.getDate() + 1),
        );
        this.getPlanning();
    }

    public setPreviousDate() {
        this.checkDate();
        this.selectedDatePlanning = new Date(
            this.selectedDatePlanning.setDate(this.selectedDatePlanning.getDate() - 1),
        );
        this.getPlanning();
    }
}
</script>

<style scoped>
.btn-holder {
    text-align: right;
}

.btn-holder #refresh-btn {
    transform: scale(0.6);
}

/*#refresh-btn {*/
/*  float: right;*/
/*}*/
</style>
